import { RefObject, useEffect, useRef, useState } from 'react';
import { findOption } from '../utils';
import { DropDownOption } from 'src/types';
import { useTranslation } from 'react-i18next';

export const useSelfValidation = ({
  isFocused,
  options,
  ref,
  selfValidate
}: {
  isFocused: boolean;
  options: DropDownOption[];
  ref: RefObject<HTMLInputElement>;
  selfValidate: boolean;
}) => {
  const { t } = useTranslation();
  const prevFocused = useRef<boolean>(false);
  const [validationError, setValidationError] = useState('');

  useEffect(() => {
    if (!selfValidate) return;
    if (!isFocused && prevFocused.current && ref.current) {
      const possibleOption = findOption(ref.current.value, options);
      if (possibleOption) {
        setValidationError('');
      } else {
        setValidationError(t('autocompleteEmptyState.selectOption') as string);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocused]);

  useEffect(() => {
    prevFocused.current = isFocused;
  }, [isFocused]);

  return {
    validationError
  };
};
